// ══════════════════════════════════════════════════════════════
// PEFEP TECH — MOYENS DE PAIEMENT (source unique partagée)
// Importé par le wizard (PageClient.js, étape 8) ET par l'éditeur
// (EditerSite.js). Une seule liste = plus jamais de divergence.
// ══════════════════════════════════════════════════════════════
export const moyensPaiement = [
  { id: 'moncash', label: 'MonCash', champ: 'Numéro MonCash', placeholder: '+509 3700 0000' },
  { id: 'natcash', label: 'NatCash', champ: 'Numéro NatCash', placeholder: '+509 3800 0000' },
  { id: 'paypal', label: 'PayPal', champ: 'Email PayPal', placeholder: 'paiement@monorganisation.com' },
  { id: 'virement_bancaire', label: 'Virement Bancaire', virementDetaille: true },
  { id: 'especes', label: 'Espèces', champ: 'Instructions', placeholder: 'Ex: Paiement à notre bureau' },
];